import React, { useRef, useState } from "react";
import axios from "axios";
import { Loader2, Send, Sparkles } from "lucide-react";

/** "Ask AI" box for a guided fix step. Keeps the conversation for the whole guide (history passed in by the parent). */
export function AskAI({ code, title, details, step, history, setHistory, testid = "ask-ai" }) {
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(false);
  const sid = useRef(`fixask-${Math.random().toString(36).slice(2)}`);
  const mine = history.filter((h) => h.step === step);
  const send = async (e) => {
    e.preventDefault();
    if (!q.trim()) return;
    setBusy(true);
    try {
      const r = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/fix/ask`,
        { code, title, details: String(details).slice(0, 2000), step, question: q, session_id: sid.current, history: history.slice(-6).map(({ q: a, a: b }) => ({ q: a, a: b })) },
        { headers: { Authorization: `Bearer ${localStorage.getItem("nex_token")}` } });
      setHistory((h) => [...h, { step, q, a: r.data.answer }]);
      setQ("");
    } catch (err) {
      setHistory((h) => [...h, { step, q, a: err?.response?.data?.detail || "Couldn't get help right now. Try again in a minute." }]);
    } finally { setBusy(false); }
  };
  return (
    <div data-testid={testid} className="mt-4 pt-3 border-t border-white/10 space-y-2">
      <div className="flex items-center gap-1.5 font-mono text-[9px] tracking-[0.18em] uppercase text-sky-300"><Sparkles className="h-3 w-3" /> Ask AI about this step</div>
      {mine.map((h, i) => (
        <div key={i} data-testid={`${testid}-msg-${i}`} className="space-y-1 text-sm">
          <p className="text-nex-silver"><span className="text-nex-muted">You:</span> {h.q}</p>
          <p className="text-sky-100/90 whitespace-pre-line pl-3 border-l border-sky-400/40">{h.a}</p>
        </div>
      ))}
      <form onSubmit={send} className="flex gap-2">
        <input value={q} onChange={(e) => setQ(e.target.value)} disabled={busy} placeholder="e.g. They said their shift ran late. What now?" data-testid={`${testid}-input`}
          className="flex-1 bg-black/40 border border-white/10 focus:border-sky-400/60 outline-none text-nex-silver text-sm px-2.5 py-1.5 rounded-sm" />
        <button type="submit" disabled={busy || !q.trim()} data-testid={`${testid}-send`}
          className="inline-flex items-center gap-1 px-3 py-1.5 border border-sky-400/60 text-sky-300 font-mono text-[9px] tracking-[0.16em] uppercase rounded-sm hover:bg-sky-500/10 disabled:opacity-40">
          {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <Send className="h-3 w-3" />} Ask</button>
      </form>
    </div>
  );
}
